import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import {
  AddressInfoDto,
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import prepareResponseFailure from '../../helpers/prepareResponseFailure';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/customerfile/${COMMON_QUERY_PARAMS.FILE_ID}/handling`;

export interface GetFileHandlingPayload {
  claimId: string;
  productLocationCountryCode: string;
  hasDeposit: boolean;
  hasDelivery: boolean;
  hasHome: boolean;
  delivery: { address: AddressInfoDto };
  deposit: {
    pickupPointAddress: AddressInfoDto;
    address: AddressInfoDto;
  };
  home: any; // empty object ?
  actorInfos: {
    id: string;
    type: string;
    address: AddressInfoDto;
  };
}
export interface GetFileHandlingArgs {
  fileId: string;
}

export const getFileHandlingRequest = ({
  fileId,
}: GetFileHandlingArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

async function getFileHandling({
  fileId,
}: GetFileHandlingArgs): Promise<
  BackResponse<GetFileHandlingPayload> | BackResponseFailure
> {
  try {
    return await executeQuery<BackResponse<GetFileHandlingPayload>>(
      getFileHandlingRequest({ fileId }),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getFileHandling;
